export function decodeHtmlCharCodes(str) { 
  if (str) {
    return str.replace(/(&#(\d+);)/g, function(match, capture, charCode) {
      return String.fromCharCode(charCode);
    });
  } else {
    return '';
  }
}